import {APIError} from '../core/errors';
import httpClient from '../services/http.service';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';
import {OrderResponse, lmrRedeemDataRequest} from '../lib/order-types';

const _api_base_url = `${BASE_URL}/order/redeem-lmr`;
//  'https://run.mocky.io/v3/fe53d798-9cb7-42c7-90ba-1765f6f50bd4';
//'http://14.142.50.123:7001/BuddyLMREnrolementWS/LSBEnrolement/LSBuddyEnrolDetails';
//TODO: - write the API calls here

// test user fetch.
// TODO: remove later
export const lmrRedeemDataApi = async (
  parameters: lmrRedeemDataRequest,
): Promise<OrderResponse> => {
  //todo
  // dob has to be non mandatory

  try {
    const response = await httpClient.post(
      `${_api_base_url}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
